import { gql } from "@apollo/client";export default gql`mutation DeleteWorksheetBlockMap($ids: [Int!]!) {
  delete_worksheet_worksheet_block_map(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
`;
